export const webClientId = '979331850861-dtetq5n1uh986rt50e7qbbsas7cfqs0a.apps.googleusercontent.com'